
import { useContext } from "react";

import ServiceStackClientContext from "../../contexts/api/ServiceStackContext"


export const useServiceStackClient = () => {
    const client = useContext(ServiceStackClientContext);

    return client;
}

export default useServiceStackClient;